import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const FilterPanel = ({ filters, onFilterChange, onReset }) => {
  const regionOptions = [
    { value: 'all', label: 'All Regions' },
    { value: 'west-africa', label: 'West Africa' },
    { value: 'east-africa', label: 'East Africa' },
    { value: 'north-africa', label: 'North Africa' },
    { value: 'southern-africa', label: 'Southern Africa' },
    { value: 'central-africa', label: 'Central Africa' }
  ];

  const positionOptions = [
    { value: 'all', label: 'All Positions' },
    { value: 'goalkeeper', label: 'Goalkeeper' },
    { value: 'defender', label: 'Defender' },
    { value: 'midfielder', label: 'Midfielder' },
    { value: 'forward', label: 'Forward' }
  ];

  const leagueOptions = [
    { value: 'all', label: 'All Leagues' },
    { value: 'premier-league', label: 'Premier League' },
    { value: 'la-liga', label: 'La Liga' },
    { value: 'bundesliga', label: 'Bundesliga' },
    { value: 'serie-a', label: 'Serie A' },
    { value: 'ligue-1', label: 'Ligue 1' }
  ];

  const timeframeOptions = [
    { value: '7days', label: 'Last 7 Days' },
    { value: '30days', label: 'Last 30 Days' },
    { value: '3months', label: 'Last 3 Months' },
    { value: '6months', label: 'Last 6 Months' },
    { value: '1year', label: 'Last Year' }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg md:text-xl font-bold text-foreground">Filters</h3>
        <Button variant="ghost" size="sm" onClick={onReset} iconName="RotateCcw" iconPosition="left">
          Reset
        </Button>
      </div>
      <div className="space-y-4">
        <Select
          label="Region"
          options={regionOptions}
          value={filters?.region}
          onChange={(value) => onFilterChange('region', value)}
        />

        <Select
          label="Position"
          options={positionOptions}
          value={filters?.position}
          onChange={(value) => onFilterChange('position', value)}
        />

        <Select
          label="Target League"
          options={leagueOptions}
          value={filters?.league}
          onChange={(value) => onFilterChange('league', value)}
        />

        <Select
          label="Timeframe"
          options={timeframeOptions}
          value={filters?.timeframe}
          onChange={(value) => onFilterChange('timeframe', value)}
        />

        <div>
          <Input
            label="Min Transfer Value (€M)"
            type="number"
            placeholder="0"
            value={filters?.minValue}
            onChange={(e) => onFilterChange('minValue', e?.target?.value)}
          />
        </div>

        <div>
          <Input
            label="Max Transfer Value (€M)"
            type="number"
            placeholder="100"
            value={filters?.maxValue}
            onChange={(e) => onFilterChange('maxValue', e?.target?.value)}
          />
        </div>

        <div>
          <Input
            label="Age Range"
            type="text"
            placeholder="18-30"
            value={filters?.ageRange}
            onChange={(e) => onFilterChange('ageRange', e?.target?.value)}
            description="Format: min-max (e.g., 18-25)"
          />
        </div>

        <div className="pt-4 border-t border-border">
          <p className="text-sm font-medium text-foreground mb-3">Alert Types</p>
          <div className="space-y-2">
            <Checkbox
              label="Transfer Opportunities"
              checked={filters?.alertTypes?.transfers}
              onChange={(e) => onFilterChange('alertTypes', { ...filters?.alertTypes, transfers: e?.target?.checked })}
            />
            <Checkbox
              label="Regulatory Updates"
              checked={filters?.alertTypes?.regulations}
              onChange={(e) => onFilterChange('alertTypes', { ...filters?.alertTypes, regulations: e?.target?.checked })}
            />
            <Checkbox
              label="Market Trends"
              checked={filters?.alertTypes?.trends}
              onChange={(e) => onFilterChange('alertTypes', { ...filters?.alertTypes, trends: e?.target?.checked })}
            />
            <Checkbox
              label="Emerging Talents"
              checked={filters?.alertTypes?.talents}
              onChange={(e) => onFilterChange('alertTypes', { ...filters?.alertTypes, talents: e?.target?.checked })}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;